import React, { useEffect, useRef, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, Polygon, Polyline } from '@react-google-maps/api';

import { Box, Typography, IconButton } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { ThemeContext } from '../../../App';

MapWithMarker.propTypes = {
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  customHeight: PropTypes.object
};

export default function MapWithMarker({ latitude, longitude, customHeight, secondLatitude, secondLongitude }) {
  const isLoaded = useContext(ThemeContext);

  const [mapLoaded, setMapLoaded] = useState(false);
  const [markerPosition, setMarkerPosition] = useState({
    lat: latitude,
    lng: longitude
  });
  

  const [zoom, setZoom] = useState(18);

  const mapRef = useRef(null);

  useEffect(() => {
    setMarkerPosition({ lat: latitude, lng: longitude });
  }, [latitude, longitude]);

  const onMapLoad = (mapInstance) => {
    mapRef.current = mapInstance;
    mapInstance.setMapTypeId('satellite');
    setMapLoaded(true);

    mapInstance.addListener('zoom_changed', () => {
      setZoom(mapInstance.getZoom());
    });
  };

  const handleRecenter = () => {
    if (!mapRef.current) return;

    const currentCenter = mapRef.current.getCenter();
    const isAlreadyCentered =
      currentCenter &&
      markerPosition &&
      currentCenter.lat().toFixed(6) === markerPosition.lat.toFixed(6) &&
      currentCenter.lng().toFixed(6) === markerPosition.lng.toFixed(6);

    if (!isAlreadyCentered) {
      const currentZoom = mapRef.current.getZoom();
      mapRef.current.setZoom(currentZoom - 1);
      mapRef.current.panTo(markerPosition);

      setTimeout(() => {
        mapRef.current.setZoom(18);
      }, 500);
    }
  };

  const options = {
    scaleControl: false,
    streetViewControl: false,
    overviewMapControl: false,
    fullscreenControl: true,
    zoomControl: false,
    rotateControl: false,
    tilt: 0,
    gestureHandling: 'greedy',
    disableDefaultUI: true,
    mapTypeControl: true
  };

  return isLoaded ? (
    <Box
      sx={{
        width: '100%',
        height: customHeight || '150px',
        border: '1px solid #B0B9C7',
        borderRadius: '10px',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {latitude == null || longitude == null ? (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography sx={{ textAlign: 'center', fontSize: '14px', fontWeight: 700 }}>
            Location not available
          </Typography>
        </Box>
      ) : (
        <GoogleMap
          onLoad={onMapLoad}
          mapContainerStyle={{ width: '100%', height: '100%' }}
          options={options}
          center={markerPosition}
          zoom={zoom}
        >
          {mapLoaded && (
            <>
              <Marker
                position={markerPosition}
                animation={window.google.maps.Animation.DROP}
                icon={{
                  url: '/static/dashboard/soundbox_home_icon.svg',
                  scaledSize: new window.google.maps.Size(50, 50), // ← increase size here
                  anchor: new window.google.maps.Point(24, 24) // optional center anchor
                }}
                zIndex={9999}
              />
              <Marker
                position={{lat: secondLatitude, lng: secondLongitude}}
                animation={window.google.maps.Animation.DROP}
                icon={{
                  url: '/static/dashboard/soundbox_home_icon.svg',
                  scaledSize: new window.google.maps.Size(50, 50), // ← increase size here
                  anchor: new window.google.maps.Point(24, 24) // optional center anchor
                }}
                zIndex={9999}
              />
            </>
          )}
        </GoogleMap>
      )}

      {/* RECENTER BUTTON */}
      {latitude != null && longitude != null && (
        <IconButton
          onClick={handleRecenter}
          sx={{
            position: 'absolute',
            bottom: 20,
            right: 8,
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            '&:hover': { backgroundColor: '#f5f5f5' },
            zIndex: 1000
          }}
          size="small"
        >
          <MyLocationIcon sx={{ width: '20px', height: '20px' }} />
        </IconButton>
      )}
    </Box>
  ) : (
    <Typography>Loading....</Typography>
  );
}
